export const mapSpendBySku = "sP6ihdMfhqdhnb3bhl0k";
